"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _freeRedeem = require("@/api/marketing/free-redeem.js");
var _permission = require("@/utils/permission");
var $constants = _interopRequireWildcard(require("@/utils/constants"));
var _clipboard = _interopRequireDefault(require("clipboard"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var statusOptions = [{
  value: 1,
  label: '待激活'
}, {
  value: 2,
  label: '已激活'
}, {
  value: 3,
  label: '已暂停'
}, {
  value: 4,
  label: '已结束'
}];
var statusMaps = statusOptions.reduce(function (acc, item) {
  acc[item.value] = item.label;
  return acc;
}, {});
var _default = exports.default = {
  data: function data() {
    return {
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      statusOptions: statusOptions,
      queryParams: {
        page: 1,
        limit: $constants.page.limit[0],
        batchName: '',
        status: ''
      }
    };
  },
  computed: {},
  filters: {
    freeRedeemStatusFilter: function freeRedeemStatusFilter(status) {
      return statusMaps[status];
    }
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['platform:free-redeem:list'])) this.getList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    //添加商品
    handleAdd: function handleAdd() {
      this.$router.push({
        path: "/marketing/free-redeem/operate/0/add"
      });
    },
    //商品操作
    handleActivity: function handleActivity(row, operate) {
      //id:商品id，operate：操作类型(edit编辑，copy复制，detail详情不可编辑)
      this.$router.push({
        path: "/marketing/free-redeem/operate/".concat(row.id, "/").concat(operate)
      });
    },
    handleStatusChange: function handleStatusChange(id, status) {
      var _this = this;
      var params = {
        id: id,
        status: status
      };
      (0, _freeRedeem.freeRedeemUpdateStatusApi)(params).then(function (res) {
        _this.$message.success('更新状态成功');
        _this.getList();
      }).catch(function () {
        _this.$message.error('更新状态失败');
      });
    },
    handleDelete: function handleDelete(row) {
      var _this2 = this;
      this.$modal.confirm('是否确认删除？').then(function () {
        return (0, _freeRedeem.freeRedeemDeleteApi)(row.id);
      }).then(function () {
        _this2.getList();
        _this2.$modal.msgSuccess('删除成功');
      }).catch(function () {});
    },
    handleQuery: function handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    //重置
    handleReset: function handleReset() {
      this.queryParams.batchName = '';
      this.queryParams.status = '';
      this.handleQuery();
    },
    // 列表
    getList: function getList() {
      var _this3 = this;
      this.listLoading = true;
      var params = _objectSpread({}, this.queryParams);
      (0, _freeRedeem.freeRedeemListApi)(params).then(function (data) {
        _this3.tableData.data = data.list;
        _this3.tableData.total = data.total;
        _this3.listLoading = false;
      }).catch(function (res) {
        _this3.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.queryParams.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryParams.limit = val;
      this.getList();
    },
    handleCommand: function handleCommand(command, row) {
      switch (command) {
        case 'appendCode':
          return this.handleAppendCode(row.id);
        case 'exportCode':
          return this.handleExportCode(row.id);
        case 'active':
          return this.handleStatusChange(row.id, 2);
        case 'pause':
          return this.handleStatusChange(row.id, 3);
        case 'end':
          return this.handleStatusChange(row.id, 4);
        case 'delete':
          return this.handleDelete(row);
      }
    },
    handleAppendCode: function handleAppendCode(id) {
      var _this4 = this;
      this.$modalPrompt('number', '追加数量', '1', {
        inputValidator: function inputValidator(value) {
          if (value === null) {
            return true;
          }
          if (!value) return '输入不能为空';
          if (value.indexOf(' ') !== -1) return '输入不能为空';
          if (value.length > 50) return '输入限制50字以内';
          if (value <= 0) {
            return '追加数量不能小于0';
          }
        }
      }).then(function (V) {
        var params = {
          batchId: id,
          appendCount: V
        };
        return (0, _freeRedeem.freeRedeemAppendCodeApi)(params);
      }).then(function (res) {
        _this4.$message.success('追加成功');
        _this4.getList();
      });
    },
    handleExportCode: function handleExportCode(id) {
      var _this5 = this;
      (0, _freeRedeem.freeRedeemExportCodeApi)(id).then(function (url) {
        if (window.location.href.indexOf('https://') === 0 && url.indexOf('http://') === 0) {
          url = url.replace('http://', 'https://');
        }
        window.open(url);
      }).catch(function () {
        _this5.$message.error('导出失败');
      });
    },
    handleCopy: function handleCopy() {
      var _this6 = this;
      this.$nextTick(function () {
        var clipboard = new _clipboard.default('.copy-data');
        clipboard.on('success', function () {
          _this6.$message.success('复制成功');
          clipboard.destroy();
        });
      });
    }
  }
};